import request from '@/utils/request'

/**
 * 查询派送方式列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listDistributionMode(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode.listDistributionMode',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加派送方式
 * @param {Object} data 派送方式数据
 * @returns {Promise} Promise对象
 */
export function saveDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode.saveDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改派送方式
 * @param {Object} data 派送方式数据
 * @returns {Promise} Promise对象
 */
export function updateDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode.updateDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除派送方式
 * @param {Object} data 派送方式数据
 * @returns {Promise} Promise对象
 */
export function deleteDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode.deleteDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}